export default __webpack_public_path__ + "assets/pdf/FT_ZN-AT.86f2588d.pdf";